import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import authService from "../../_services/cart/authService";

/**
 * Cartel fijo arriba mientras un admin impersona a un usuario: que nunca se olvide de que lo que hace
 * queda a nombre de otra persona, y una salida a mano en cualquier pantalla (el panel, el sitio, el
 * checkout). Entrar y salir recargan la app, asi que alcanza con leerlo al montar.
 */
export const ImpersonacionBanner = () => {
    const info = authService.impersonando();
    if (!info) return null;

    return (
        <div className="impersonacion-banner" role="status">
            <FontAwesomeIcon icon="fa-solid fa-user-secret"/>
            <span className="impersonacion-banner__texto">
                Estás viendo DeAutopartes como <strong>{info.nombre || info.email}</strong>
                {info.cuentaNombre && <span className="impersonacion-banner__cuenta"> de {info.cuentaNombre}</span>}
            </span>
            <button type="button" className="impersonacion-banner__salir"
                    onClick={() => authService.salirImpersonacion()}>
                <FontAwesomeIcon icon="fa-solid fa-arrow-right-from-bracket"/> Volver a mi usuario
            </button>
        </div>
    );
};
